"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function MyPhilosophy() {
  const intro = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const pillarsBlock = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const pillars = [{
    glyph: "01",
    title: "Precision Over Volume",
    body: "I do not believe in mindless repetition. Every movement is calculated, every set is intentional, and every rep is a step toward your peak."
  }, {
    glyph: "02",
    title: "Science as Foundation",
    body: "Fitness is not a guessing game. I rely on biomechanics and physiological data to build programs that respect your body's unique architecture."
  }, {
    glyph: "03",
    title: "Consistency in Motion",
    body: "true transformation happens in the quiet, disciplined moments between sessions. I provide the structure; you provide the relentless effort."
  }];
  return <section data-section-id="299" id="my-philosophy" className="dark bg-background text-foreground relative overflow-hidden py-32 md:py-[200px] px-6">
      {}
      <div className="absolute inset-0 bg-cover bg-center opacity-10 pointer-events-none" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/training_intensity.webp)"
    }} aria-hidden="true" />
      <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/training_intensity.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/training_intensity.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/training_intensity.webp-wvc-sizes" alt="" aria-hidden="true" loading="lazy" decoding="async" className="hidden" />

      <div className="relative mx-auto max-w-6xl">
        {}
        <div ref={intro.ref} className={`mx-auto max-w-[760px] text-center transition-all duration-[1200ms] ease-out ${intro.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-default text-xs md:text-sm tracking-[0.35em] uppercase mb-10" style={{
          color: "var(--primary)"
        }}>
            The Methodology — 
          </p>

          <h2 className="font-default font-bold text-foreground text-4xl sm:text-5xl md:text-6xl lg:text-[64px] leading-[1.1] tracking-tight">
            On why I build <em className="italic font-light">performance</em>.
          </h2>

          <p className="font-default font-light text-foreground/85 text-xl md:text-2xl leading-[1.7] mt-12">
            Fitness, to me, is not a temporary aesthetic goal — it is a lifelong commitment to your own potential. It is the discipline found in the early morning, the focus during a heavy lift, and the resilience built through every challenge. I do not offer generic routines; I offer a blueprint for your evolution. I wait for the breakthrough, for the form to sharpen, and for the mental barriers to dissolve. What I build is not just a stronger body, but a more capable version of you.
          </p>
        </div>

        {}
        <div className="flex justify-center mt-20 mb-20 md:mt-24 md:mb-24">
          <Separator className="w-20 h-px" style={{
          backgroundColor: "var(--primary)",
          opacity: 0.6
        }} />
        </div>

        {}
        <div ref={pillarsBlock.ref} className={`grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16 transition-all duration-[1200ms] ease-out ${pillarsBlock.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {pillars.map((pillar, i) => <div data-index={i} key={pillar.title} className="flex flex-col items-center text-center">
              <span className="font-default text-3xl md:text-4xl mb-6 leading-none" style={{
            color: "var(--primary)"
          }} aria-hidden="true">
                {pillar.glyph}
              </span>
              <h3 className="font-default font-semibold text-foreground text-2xl md:text-[26px] leading-snug mb-5">
                {pillar.title}
              </h3>
              <p className="font-default text-foreground/80 text-base leading-[1.7] max-w-xs">
                {pillar.body}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}